export type ValidationReturn = string | null;

export type CompanyName = {
  value: string;
  shouldValidate: boolean;
  isAuthenticated: boolean;
};

export const validateMandatory = (val: string): ValidationReturn => {
  return !val ? 'validationBlock.missingMandatory' : null;
};

export const validateAccept = (val: string): ValidationReturn => {
  return !val ? 'validationBlock.missingAcceptance' : null;
};
export const validateState = (val: string): ValidationReturn => {
  return !val ? 'validationBlock.noSelectedState' : null;
};

export const validateReason = (val: string): ValidationReturn => {
  return !val ? 'validationBlock.noSelectedReason' : null;
};

export const validateInvalidCharacters = (
  val: string | CompanyName,
  maxLength?: number,
  optional = false,
  regExp?: RegExp,
  disallowedRegExp?: RegExp
): ValidationReturn => {
  if (val === undefined) {
    return optional === false ? validateMandatory('') : null;
  }
  const trimmedValue = typeof val === 'string' ? val.trim() : val.value.trim();
  const emptyMessage = validateMandatory(trimmedValue);

  if (emptyMessage) {
    return optional ? null : emptyMessage;
  }

  const pattern = /^(?!.*https?:\/\/|.*www\.|.*\.com)(?![ ¡!¿?"#$%&'()*+,-./:<=>@[\]^_`{|}~\d\s]*$)[^\u25CF<>{}[\]()=*;]+$/i;
  const hasInvalidLength = !!maxLength && trimmedValue.length > maxLength;

  if (!pattern.test(trimmedValue)) {
    return 'validationBlock.nameInvalid';
  }
  // give error if we cannot find a match with regExp pattern.
  if (regExp && !regExp.test(trimmedValue)) {
    return 'validationBlock.nameInvalid';
  }
  // throw error if disallowed patterns are found
  if (disallowedRegExp && disallowedRegExp.test(trimmedValue)) {
    return 'validationBlock.nameInvalid';
  }
  if (hasInvalidLength) {
    return 'validationBlock.maxNumberOfCharactersExceeded';
  }

  return null;
};

export const validateCompanyName = (maxLength?: number) => ({
  value,
  shouldValidate,
}: CompanyName): ValidationReturn => {
  return shouldValidate ? validateInvalidCharacters(value, maxLength) : null;
};
